import React from 'react'
import { pure } from 'recompose'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Toolbar from 'material-ui-next/Toolbar'
import withStyles from 'material-ui-next/styles/withStyles'
import MediaQuery from 'react-responsive'
import breakpoints from '../../../styles/breakpoints'
import WorldsAndCategoriesDropdowns from '../WorldsAndCategoriesDropdowns'
import FilterButton from '../FilterButton'
import FilterChip from '../FilterChip'
import { getCategory, getTopBarConfig } from '../../../selectors'
import { uiConfigureTopBar } from '../../../actions'

const styles = theme => ({
  toolbar: {
    ...theme.swapick.styles.toolbars.secondaryToolbar,
    justifyContent: 'space-between',
  },
  search: {
    marginRight: 2,
  },
  ...theme.swapick.styles.toolbars,
})

const makeLinkTo = ({ world, category }) => {
  if (category) {
    return `/category/${category.slug}`
  }
  if (world) {
    return `/world/${world.slug}`
  }
  return '/all-worlds'
}

const CategoryToolbar = ({
  classes,
  pageMatch,
  category,
  uiConfigureTopBar,
}) => (
  <Toolbar className={classes.toolbar}>
    <MediaQuery maxWidth={breakpoints.xs}>
      {isMobile => (
        <WorldsAndCategoriesDropdowns
          biggerFontOnMobile
          showAllWorlds={true}
          hideWorlds={isMobile}
          makeLinkTo={makeLinkTo}
          categorySlug={pageMatch.params.category}
        />
      )}
    </MediaQuery>

    {category && (
      <div className={classes.toolbarGroup}>
        <MediaQuery minWidth={breakpoints.xs}>
          <FilterChip />
        </MediaQuery>
        <FilterButton />
      </div>
    )}
  </Toolbar>
)

const mapStateToProps = (state, ownProps) => ({
  category: getCategory(state, ownProps.pageMatch.params.category),
})

export default withRouter(
  withStyles(styles)(connect(mapStateToProps)(pure(CategoryToolbar)))
)



// WEBPACK FOOTER //
// ./src/common/TopBar/SecondaryToolbars/CategoryToolbar.js